export class Ward {
    constructor(public id: string, public districtid: string, public name: string) { }
  }
  